import styled from 'styled-components';
import WBSelect from './elements/WBSelect';

export const RowCountSelect = styled(WBSelect)`
  font-size: 13px;
  text-align: right;
`;

export const RowCountSelectWrapper = styled.div`
  display: flex;
  align-items: center;
  .select-label {
    white-space: nowrap;
    font-size: 13px;
  }
`;

export const RowContextWrapper = styled.div`
  font-size: 13px;
  margin-right: 24px;
  text-align: right;
  margin-left: 12px;
`;

export const PageNav = styled.div`
  .ui.buttons .button:first-child {
    border-left: none;
  }
  .wb-icon-button.only-icon {
    border: none;
    border-radius: 50%;
  }
  .ui.buttons .button:last-child,
  .ui.buttons .button:first-child {
    border-radius: 50%;
  }
  .ui.button {
    background: none;
    &:focus,
    &:hover {
      background: #f4f4f4;
    }
  }
  .ui.button:disabled,
  .ui.buttons .disabled.button,
  .ui.disabled.active.button,
  .ui.disabled.button,
  .ui.disabled.button:hover {
    background: none;
  }
`;
